(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("learningItemEditWebinarTab", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/learningItems/edit/learningItemType/learningItemEditWebinarTabView.html",
            controller: ["learningItemWebinarArchivesResource", "$scope", "$localStorage", "$uibModal", "calendarSettingsService", "messageService", "_", LearningItemEditWebinarTabCtrl],
            controllerAs: "vm"
        };
        function LearningItemEditWebinarTabCtrl(learningItemWebinarArchivesResource, $scope, $localStorage, $uibModal, calendarSettingsService, messageService, _) {
            var vm = this;
            vm.loading = true;
            vm.enabledLanguages = $localStorage.tenantSettings.enabledLocalizations;
            vm.format = "yyyy-MM-dd";
            calendarSettingsService.calendarSetup($scope);
            vm.open = calendarSettingsService.openToggle;
            ////Date picker Config
            vm.datePickerList = [];
            $scope.$parent.vm.learningItemResourceObject.$promise.then(function () {
                vm.learningItem = $scope.$parent.vm.learningItem;
                vm.localizedArchives = _.groupBy(vm.learningItem.learningItemWebinarArchives, 'localizationId');
            }).catch(angular.noop);
            vm.editTypeModal = function () {
                var $modalInstance = $uibModal.open({
                    templateUrl: "/app/learningItems/edit/learningItemType/learningItemEditWebinarTypeModalView.html",
                    controller: "LearningItemEditWebinarTypeModalCtrl as vm",
                    size: "lg",
                    resolve: {
                        learningItemWebinar: {
                            webinarTypeId: vm.learningItem.learningItemWebinarType.webinarTypeId,
                            learningItemId: vm.learningItem.id
                        }
                    }
                });
                $modalInstance.result.then(function (result) {
                    vm.learningItem.learningItemWebinarType.webinarTypeId = result;
                }).catch(angular.noop);
            };
            vm.openModal = function (archive, localizationId) {
                var $modalInstance = $uibModal.open({
                    templateUrl: "/app/learningItems/edit/learningItemType/learningItemEditWebinarModalView.html",
                    controller: "LearningItemEditWebinarModalCtrl as vm",
                    size: "lg",
                    resolve: {
                        learningItemWebinarArchive: {
                            archive: angular.copy(archive),
                            localizationId: localizationId,
                            learningItemId: vm.learningItem.id
                        }
                    }
                });
                $modalInstance.result.then(function (result) {
                    if (!vm.localizedArchives[result.localizationId])
                        vm.localizedArchives[result.localizationId] = [];
                    var nonEditedArchive = _.find(vm.localizedArchives[result.localizationId], function (item) {
                        return item.id === result.id;
                    });
                    if (nonEditedArchive)
                        vm.localizedArchives[result.localizationId] = _.without(vm.localizedArchives[result.localizationId], nonEditedArchive);
                    vm.localizedArchives[result.localizationId].push(result);
                }).catch(angular.noop);
            };
            vm.openAddModal = function (localizationId) {
                vm.openModal(null, localizationId);
            };
            vm.deleteArchive = function (archive) {
                var modal = $uibModal.open({
                    templateUrl: "deleteWebinarArchive.html",
                    backdrop: false,
                    animation: false,
                    windowClass: "confirmation-modal"
                });
                modal.result.then(function () {
                    learningItemWebinarArchivesResource.delete({ learningItemId: vm.learningItem.id, id: archive.id }, function () {
                        vm.localizedArchives[archive.localizationId] = _.without(vm.localizedArchives[archive.localizationId], archive);
                        messageService.success("learningItem.updatedSuccessMessage");
                    }, function (error) {
                        messageService.error(error);
                    });
                }).catch(angular.noop);
            };
        }
    });
})();
